/**
 * Opening-hours status.
 *
 * Answers the only question the page exists for — is the shop open right now —
 * and does it in Europe/Copenhagen, not the visitor's clock. Someone checking
 * from Germany is an hour ahead; on their own time the shop would appear to shut
 * at 16:00.
 *
 * Renders closed and marks itself open only once it has proved the shop is. The
 * opposite default would be wrong for most of the week, and wrong for every day
 * of a closure.
 */
(function () {
  var el = document.querySelector('[data-sh-status]');
  if (!el) return;

  var TZ = 'Europe/Copenhagen';
  var text = el.querySelector('[data-sh-status-text]');
  var closedDays = (el.getAttribute('data-closed-days') || '').split(',').map(function (d) { return d.trim(); });
  var names = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  /** Local time in Copenhagen, whatever the visitor's own timezone. */
  function shopNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(new Date());
    var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
    var short = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[get('weekday')];
    return {
      dow: short,
      minutes: Number(get('hour')) * 60 + Number(get('minute')),
      iso: get('year') + '-' + get('month') + '-' + get('day'),
    };
  }

  /** "11:00 — 17:00" -> [660, 1020]. Tolerates any dash and stray spaces. */
  function parseRange(value) {
    var found = String(value || '').match(/(\d{1,2})[:.](\d{2})/g);
    if (!found || found.length < 2) return null;
    return found.slice(0, 2).map(function (t) {
      var b = t.split(/[:.]/);
      return Number(b[0]) * 60 + Number(b[1]);
    });
  }

  function hoursFor(dow) {
    if (closedDays.indexOf(names[dow]) !== -1) return null;
    return parseRange(dow === 6 ? el.getAttribute('data-saturday') : el.getAttribute('data-weekday'));
  }

  /* A closure beats the weekly schedule: the shop can be shut on a Tuesday. */
  function inClosure(iso) {
    if (el.getAttribute('data-notice-on') !== '1') return false;
    var from = el.getAttribute('data-notice-from');
    var to = el.getAttribute('data-notice-to');
    return Boolean(from && to && iso >= from && iso <= to);
  }

  function dayName(dow) {
    var row = document.querySelector('[data-sh-day="' + ((dow + 6) % 7) + '"] .sh__day');
    return row ? row.textContent.trim() : '';
  }

  function hhmm(mins) {
    return String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0');
  }

  var closureNote = document.querySelector('[data-sh-closure]');
  var list = document.querySelector('[data-sh-list]');

  function render() {
    var now = shopNow();
    var closed = inClosure(now.iso);

    /* During a closure the week below is not this week, so it is dimmed and
       captioned rather than left to be misread as today's hours. */
    if (closureNote) closureNote.hidden = !closed;
    if (list) list.classList.toggle('sh__list--suspended', closed);
    var today = closed ? null : hoursFor(now.dow);
    var open = Boolean(today) && now.minutes >= today[0] && now.minutes < today[1];

    el.classList.toggle('sh__status--open', open);

    if (open) {
      text.textContent = el.getAttribute('data-open-now') +
        ' · ' + el.getAttribute('data-closes-at').replace('__T__', hhmm(today[1]));
      return;
    }

    /* Look ahead for the next day that is actually open, closure included, so
       "opens Monday 11:00" is never a day the shop is shut. */
    for (var step = 0; step <= 14; step++) {
      var dow = (now.dow + step) % 7;
      var probe = new Date(Date.now() + step * 86400000);
      var iso = new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(probe);
      if (inClosure(iso)) continue;
      var range = hoursFor(dow);
      if (!range) continue;
      if (step === 0 && now.minutes >= range[0]) continue;
      text.textContent = el.getAttribute('data-closed-now') + ' · ' +
        el.getAttribute('data-opens-at')
          .replace('__D__', step === 0 ? '' : dayName(dow))
          .replace('__T__', hhmm(range[0]))
          .replace(/\s+/g, ' ')
          .trim();
      return;
    }
    text.textContent = el.getAttribute('data-closed-now');
  }

  /* Mark today's row so the line a visitor wants is found without counting. */
  (function markToday() {
    var todayLabel = (document.querySelector('.sh') || {}).getAttribute
      ? document.querySelector('.sh').getAttribute('data-sh-today-label')
      : '';
    var dow = shopNow().dow;
    var row = document.querySelector('[data-sh-day="' + ((dow + 6) % 7) + '"]');
    if (!row) return;
    row.classList.add('sh__row--today');
    var day = row.querySelector('.sh__day');
    if (day && todayLabel) day.setAttribute('data-today', todayLabel);
  })();

  render();
  /* The status goes stale if a tab is left open across an opening time. */
  window.setInterval(render, 60000);
})();
